import React from 'react';
import PropTypes from 'prop-types';
import {
  Select,
  SelectOption,
} from '@americanexpress/dls-react';

const DropDown = ({
  id,
  value,
  handleSelection,
  showOptions,
  options,
}) => (
  <Select
    id={id}
    value={value}
    onChange={handleSelection}
    className="width-full"
    fluid={true}
  >
    {
                showOptions && options.map((item) => (
                  <SelectOption
                    key={item.financialInstitutionAccount.institutionIdentifier}
                    value={JSON.stringify(item)}
                    className="pad-2"
                  >
                    {`${item.financialInstitutionAccount.institutionName} - ${item.financialInstitutionAccount.accountIdentifierRedacted}`}
                  </SelectOption>
                ))
            }
  </Select>
);

DropDown.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  handleSelection: PropTypes.func,
  showOptions: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    financialInstitutionAccount: PropTypes.shape({
      institutionIdentifier: PropTypes.string.isRequired,
      institutionName: PropTypes.string.isRequired,
      accountIdentifierRedacted: PropTypes.string.isRequired,
    }).isRequired,
    arrangementManagerEnrollmentId: PropTypes.string,
    preferred: PropTypes.bool,
    status: PropTypes.string,
  })).isRequired,
};

export default DropDown;
